(function () {
	'use strict';

	angular.module('dcApp').service('RepositoryService', RepositoryService);

	RepositoryService.$inject = [
		'$rootScope',
		'$http',
		'UrlService',
		'UrlParamService',
	];

	function RepositoryService($rootScope, $http, UrlService, UrlParamService) {
		this.getRepositoryById = getRepositoryById;
		this.createRepository = createRepository;
		this.updateRepository = updateRepository;
		this.deleteRepository = deleteRepository;
		this.getHeadersFromSchema = getHeadersFromSchema;
		this.getRemoteFilePreview = getRemoteFilePreview;
		this.deleteAllHeaders = deleteAllHeaders;
		this.deleteFileByName = deleteFileByName;
		this.getExtractionPreview = getExtractionPreview;
		this.deleteRepoExtraction = deleteRepoExtraction;
		this.createFilter = createFilter;
		this.deleteFilterById = deleteFilterById;
		this.updateFilterById = updateFilterById;
		this.getFiltersByRepositoryId = getFiltersByRepositoryId;
		this.getExtractionsByRepositoryId = getExtractionsByRepositoryId;
		this.getHeadersByRepositoryId = getHeadersByRepositoryId;
		this.getRemoteFilesByRepositoryId = getRemoteFilesByRepositoryId;
		this.detectCharsetByRepositoryId = detectCharsetByRepositoryId;
		this.createExtractionByRepositoryId = createExtractionByRepositoryId;
		this.getQueryPreview = getQueryPreview;

		function updateFilterById(filterId, filter) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_FILTERS_BY_ID',
				{ filterId: filterId },
				{}
			);
			return $http.put(url, filter).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function deleteFilterById(filterId) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_FILTERS_BY_ID',
				{ filterId: filterId },
				{}
			);
			return $http.delete(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function createFilter(repoId, filter) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_FILTERS',
				{
					repositoryId: repoId,
				},
				{}
			);
			return $http.post(url, filter).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function getFiltersByRepositoryId(repoId) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_FILTERS',
				{ repositoryId: repoId },
				{}
			);
			return $http.get(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function deleteRepoExtraction(repoId, extractionName) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_EXTRACTIONS',
				{ repositoryId: repoId },
				{
					extractionName:
						UrlParamService.escapeCharsForEncoding(extractionName),
				}
			);
			return $http.delete(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function getExtractionPreview(repoId, extractionName) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_EXTRACTIONS_PREVIEW',
				{
					repositoryId: repoId,
				},
				{
					extractionName: extractionName,
					useCache: !!$rootScope.jobCacheActive,
				}
			);
			return $http.get(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function getExtractionsByRepositoryId(repoId) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_EXTRACTIONS',
				{
					repositoryId: repoId,
				},
				{}
			);
			return $http.get(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function createExtractionByRepositoryId(repoId) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_EXTRACTIONS',
				{
					repositoryId: repoId,
				},
				{}
			);
			return $http.post(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function createRepository(repository) {
			const url = UrlService.generateUrl('REPOSITORIES_PRIVATE', {}, {});
			return $http.post(url, repository).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function updateRepository(repository) {
			const url = UrlService.generateUrl('REPOSITORIES_PRIVATE_BY_ID', {
				repositoryId: repository.id,
			});
			return $http.put(url, repository).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function deleteRepository(repoId) {
			const url = UrlService.generateUrl('REPOSITORIES_PRIVATE_BY_ID', {
				repositoryId: repoId,
			});
			return $http.delete(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function getRepositoryById(repoId) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_BY_ID',
				{ repositoryId: repoId },
				{}
			);
			return $http.get(url).then(function (response) {
				return response;
			});
		}

		function deleteAllHeaders(repoId) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_HEADERS',
				{ repositoryId: repoId },
				{}
			);
			return $http.delete(url).then(function (response) {
				return response;
			});
		}

		function detectCharsetByRepositoryId(repoId) {
			const url = UrlService.generateUrl(
				'REPOSITORY_CHARSET',
				{ repositoryId: repoId },
				{}
			);
			return $http.get(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function getHeadersByRepositoryId(repoId) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_HEADERS',
				{ repositoryId: repoId },
				{}
			);
			return $http.get(url).then(function (response) {
				return response;
			});
		}

		function getHeadersFromSchema(schema) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_HEADERS_FROM_SCHEMA',
				{ schema: schema },
				{}
			);
			return $http.post(url, schema).then(function (response) {
				return response;
			});
		}

		function getRemoteFilesByRepositoryId(
			repoId,
			path,
			filenameMask,
			limit,
			includeTemp
		) {
			const url = UrlService.generateUrl(
				'REPOSITORIES_REMOTE_FILES',
				{ repositoryId: repoId },
				{
					limit: limit,
					includeTemp: includeTemp !== undefined ? includeTemp : false,
					filenameMask: UrlParamService.escapeCharsForEncoding(filenameMask),
					remotePath: path ? UrlParamService.escapeCharsForEncoding(path) : '',
				}
			);
			return $http.get(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function getRemoteFilePreview(repoId, fileName) {
			let name = encodeURIComponent(fileName);
			const url = UrlService.generateUrl(
				'REPOSITORIES_REMOTE_FILES_PREVIEW',
				{ repositoryId: repoId },
				{
					fileName: UrlParamService.escapeCharsForEncoding(name),
					useCache: !!$rootScope.jobCacheActive,
				}
			);
			return $http.get(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function deleteFileByName(repoId, file) {
			let fileName = encodeURIComponent(file.name);
			let isTemp = file.temp !== undefined ? file.temp : false;
			const url = UrlService.generateUrl(
				'REPOSITORIES_REMOTE_FILES',
				{ repositoryId: repoId },
				{
					fileName: UrlParamService.escapeCharsForEncoding(fileName),
					isTemp: isTemp,
				}
			);
			return $http.delete(url).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}

		function getQueryPreview(repository) {
			const url = UrlService.generateUrl('REPOSITORIES_DATA_PREVIEW', {}, {});
			return $http.post(url, repository).then(
				function (response) {
					return response;
				},
				function (err) {
					return $q.reject(err);
				}
			);
		}
	}
})();
